module.exports = __webpack_public_path__ + "static/img/decidoc-04.2acd599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decidoc-04.png
// module id = 77
// module chunks = 0